module.exports = __webpack_public_path__ + "4234d42cf859bb9abd45d6b5f09452d8.png";